module.exports = __webpack_public_path__ + "img/phone.ea78a628.jpg";